<template>
  <div class="w-full p-6 bg-slate-50 min-h-screen">
    <div class="max-w-5xl mx-auto">
      <div class="bg-white rounded-lg shadow-sm border border-slate-200 overflow-hidden">
        
        <!-- HEADER -->
        <div class="px-6 py-4 flex items-center gap-3" style="background-color: #333333;">
          <v-icon color="orange" small>mdi-file-document-edit</v-icon>
          <span class="text-white font-bold uppercase text-sm tracking-widest">
            CADASTRO DE SITUAÇÃO
          </span>
        </div>

        <div class="p-8">
          <!-- SEÇÃO 1: DADOS DO VEÍCULO -->
          <div class="mb-8 border-b border-slate-200 pb-8">
            <div class="flex items-center gap-2 mb-6">
              <div class="w-2 h-2 rounded-full bg-orange-500"></div>
              <h3 class="text-xs font-bold text-slate-500 uppercase tracking-wider">Dados do Veículo</h3>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-12 gap-6">
              <!-- Prefeitura -->
              <div class="md:col-span-12">
                <label class="block text-[10px] font-bold uppercase text-slate-500 mb-1">Prefeitura</label>
                <select
                  v-model="data.prefecture_id"
                  @change="getVehicles(data.prefecture_id)"
                  class="w-full bg-slate-50 border border-slate-200 rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors"
                >
                  <option :value="null" disabled>Selecione a Prefeitura...</option>
                  <option v-for="item in prefectures" :key="item.prefecture_id" :value="item.prefecture_id">
                    {{ item.prefecture_social_name }}
                  </option>
                </select>
              </div>

              <!-- Veículo -->
              <div class="md:col-span-12">
                <label class="block text-[10px] font-bold uppercase text-slate-500 mb-1">Veículo</label>
                <select
                  v-model="data.vehicle_id"
                  class="w-full bg-slate-50 border border-slate-200 rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors"
                  :disabled="!vehicles.length"
                >
                  <option :value="null" disabled>Selecione um veículo...</option>
                  <option v-for="item in vehicles" :key="item.vehicle_id" :value="item.vehicle_id">
                    {{ item.brand_desc }} - {{ item.model_desc }} - {{ item.vehicle_categoria == 1 ? item.vehicle_board : item.vehicle_cod_maquina }}
                  </option>
                </select>
              </div>

              <!-- Data -->
              <div class="md:col-span-6">
                <label class="block text-[10px] font-bold uppercase text-slate-500 mb-1">Data</label>
                <input 
                  type="date"
                  v-model="data.data"
                  class="w-full bg-slate-50 border border-slate-200 rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors"
                >
              </div>

              <!-- Situação -->
              <div class="md:col-span-6">
                <label class="block text-[10px] font-bold uppercase text-slate-500 mb-1">Tipo da Situação</label>
                <select
                  v-model="data.situacao"
                  class="w-full bg-slate-50 border border-slate-200 rounded px-3 py-2.5 text-sm text-slate-700 focus:outline-none focus:border-orange-500 focus:ring-1 focus:ring-orange-500 transition-colors"
                >
                  <option :value="null" disabled>Selecione a situação...</option>
                  <option :value="1">Em Uso</option>
                  <option :value="2">Em Manutenção</option>
                  <option :value="3">Baixada</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <!-- Rodapé -->
        <div class="bg-slate-50 px-8 py-5 border-t border-slate-200 flex justify-end items-center gap-4">
          <button 
            @click="$router.back()"
            class="text-slate-500 hover:text-slate-700 font-bold text-[11px] uppercase px-4 py-2 transition-colors flex-none"
          >
            Cancelar
          </button>
          <div class="flex-none">
            <button
              @click="validate"
              :disabled="loader"
              class="bg-orange-500 hover:bg-orange-600 text-white font-bold text-[11px] px-6 py-2.5 rounded shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all w-auto max-w-max whitespace-nowrap flex items-center gap-2"
            >
              <v-icon small color="white" class="mr-1" style="font-size: 14px;">mdi-check</v-icon>
              <span v-if="loader" class="animate-spin h-3 w-3 border-2 border-white border-t-transparent rounded-full"></span>
              <span v-else>CONFIRMAR CADASTRO</span>
            </button>
          </div>
        </div>

      </div>
    </div>

    <!-- Snackbar (Mantis) -->
    <v-snackbar
      multi-line
      :color="snack.color"
      v-model="snack.show"
      transition="fade-transition"
    >
      {{ snack.message }}
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snack.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  props: ["id"],
  data: () => ({
    valid: false,
    loader: false,
    prefectures: [],
    vehicles: [],
    snack: {
      show: false,
      message: "",
      color: "success",
    },
    data: {
      vehicle_id: null,
      prefecture_id: null,
      situacao: null,
      data: null,
    },
  }),
  created() {
    this.$http.get("prefectures").then((r) => (this.prefectures = r.data));
  },
  methods: {
    getVehicles(prefecture_id) {
      if (!prefecture_id) return;
      this.$http.get(`/vehicles/prefectures/${prefecture_id}`).then((r) => {
        this.vehicles = r.data;
      });
    },
    validate() {
      // Validação manual simples
      if (!this.data.prefecture_id || !this.data.vehicle_id || !this.data.data || !this.data.situacao) {
        this.snack.show = true;
        this.snack.color = "warning";
        this.snack.message = "Atenção: Todos os campos precisam ser preenchidos!";
        return;
      }
      this.createOrUpdate();
    },
    createOrUpdate() {
      this.loader = true;
      this.$store.dispatch("setLoader", this.loader);
      this.$http
        .post("/vehicles/situacao", this.data)
        .then(() => {
          this.snack.show = true;
          this.snack.message = "Criado com sucesso!";
          this.snack.color = "success";
          this.loader = false;
          this.$store.dispatch("setLoader", this.loader);
          setTimeout(() => {
            this.$router.push("/vehicles-manager/situacao");
          }, 1500);
        })
        .catch((e) => {
          this.snack.show = true;
          this.snack.message = e.message;
          this.snack.color = "error";
          this.loader = false;
          this.$store.dispatch("setLoader", false);
        });
    },
  },
};
</script>

<style scoped>
/* Scoped styles mainly for specific overrides if needed, mostly using Tailwind classes */
</style>
